﻿import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ArcoVue from '@arco-design/web-vue'
import ArcoVueIcon from '@arco-design/web-vue/es/icon'
import '@arco-design/web-vue/dist/arco.css'
import './assets/style/mobile.scss'
import App from './App.vue'
import router from './router'
import { ensureCsrfToken } from './utils/request'
import './assets/style/global.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ArcoVue)
app.use(ArcoVueIcon)
// 全局错误捕获
app.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', err, info)
}
window.addEventListener('error', (e) => {
  console.error('[Global Error]', e.message, e.filename, e.lineno)
})
window.addEventListener('unhandledrejection', (e) => {
  console.error('[Unhandled Promise]', e.reason)
})

// 预取 CSRF token 后再挂载：已登录用户刷新/直达 dashboard 时 csrfToken 内存为空，
// 首屏并发 POST 会因无 token 触发 CSRFTokenError 400（拦截器虽会重试救回，但每次刷新都刷屏）。
// 此处 mount 前取好 token（未登录时返回 null，不影响登录页），彻底消除首屏 CSRF 竞态。
async function bootstrap() {
  await ensureCsrfToken()
  app.mount('#app')
}
bootstrap()
